import React from "react"
import "../noteControls/NoteControls";
import "../noteForm/noteForm";
import "../../styles/reset.css";
import "./Note.css";


class Note extends React.Component {
    render() {
        const { title, text, color } = this.props.note;

        return (
            <React.Fragment>
                <article className={`note note_color_${color}`} onClick={() => this.props.onClick()}>
                    <h3 className="note__title">{title}</h3>
                    <p className="note__text">{text}</p>
                </article>
            </React.Fragment>
        );
    }
}

export default Note;
